import styled from "styled-components";

export const StyledContainer = styled.main`
	margin-left: 45px;
`